export const EAVE_GABLE_SOFFIT_TYPE_FOR_TG_WIDTH = [
    'CEDAR TG',
    'PINE TG',
    'TG PAT122',
    '#2YP PAT122',
    'D YP TG SPRUCE AQUA SEAL',
    'V GROOVE',
    'FINE LINE',
    'BEADED CEILING',
]

// options in soffit type which display conditional field soffit_vent_type
export const EAVE_GABLE_SOFFIT_TYPE_VENT_TYPES = [
    '4X8 BC PLY',
    '4X8 FC',
    '4X8 PANEL CEDAR',
    '4X8 PLYBEAD',
    '4X8 PLYWOOD',
    '4X8 ROUGH SAWN',
    '4X8 LP SMARTFIBER (3/8)',
    '4X8 T111',
    'CEDAR TG',
    'CHANNEL RUSTIC CEDAR',
    'PANEL',
    'PANEL (4X8)',
    'DIMENSIONAL LUMBER',
    'FIBER CEMENT',
    'LP',
]

export const EAVE_GABLE_SOFFIT_TYPES_EXPOSED_SOFFIT = ['DIMENSIONAL LUMBER', 'PANEL (4X8)', 'SQ FT']

export const dimensionsSuffixKey = 'dimensions'

export const dimensionsMultipleKey = 'multiple'

// used to map setting key to dimensions key
export const settingsFieldToDimensionsFieldMap = {
    soffit_type: 'soffit',
    fascia_type: 'fascia_1',
    fascia_type_2: 'fascia_2',
    frieze_type: 'frieze_1',
    frieze_type_2: 'frieze_2',
}

// used to set field key and field values where 'multiple' should be used as dimensions key
export const dimensionsMultipleKeyCheck = {
    soffit_type: ['aluminum', 'fiber cement', 'vinyl', 'steel'],
}

export const soffitDimensionsFieldKeys = [
    'soffit_dimensions',
    'soffit_multiple_dimensions',
    'soffit_dimensional_lumber_dimensions',
    'soffit_lp_dimensions',
    'soffit_pvc_dimensions',
]

export const fascia1DimensionsFieldKeys = [
    'fascia_1_aluminum_dimensions',
    'fascia_1_dimensional_lumber_dimensions',
    'fascia_1_fiber_cement_dimensions',
    'fascia_1_lp_dimensions',
    'fascia_1_lf_dimensions',
    'fascia_1_pvc_dimensions',
    'fascia_1_steel_dimensions',
    'fascia_1_woodtone_dimensions',
    'fascia_1_cemtrim_dimensions',
]

export const fascia2DimensionsFieldKeys = [
    'fascia_2_dimensional_lumber_dimensions',
    'fascia_2_fiber_cement_dimensions',
    'fascia_2_lp_dimensions',
    'fascia_2_aluminum_dimensions',
    'fascia_2_lf_dimensions',
    'fascia_2_pvc_dimensions',
    'fascia_2_steel_dimensions',
    'fascia_2_woodtone_dimensions',
    'fascia_2_cemtrim_dimensions',
]

export const frieze1DimensionsFieldKeys = [
    'frieze_1_dimensional_lumber_dimensions',
    'frieze_1_fiber_cement_dimensions',
    'frieze_1_lp_dimensions',
    'frieze_1_aluminum_dimensions',
    'frieze_1_lf_dimensions',
    'frieze_1_pvc_dimensions',
    'frieze_1_steel_dimensions',
    'frieze_1_woodtone_dimensions',
    'frieze_1_cemtrim_dimensions',
]

export const frieze2DimensionsFieldKeys = [
    'frieze_2_dimensional_lumber_dimensions',
    'frieze_2_fiber_cement_dimensions',
    'frieze_2_lp_dimensions',
    'frieze_2_aluminum_dimensions',
    'frieze_2_lf_dimensions',
    'frieze_2_pvc_dimensions',
    'frieze_2_steel_dimensions',
    'frieze_2_woodtone_dimensions',
    'frieze_2_cemtrim_dimensions',
]
